import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { ApiService } from "./api.service";
import { API_ROUTE } from "app/api-routes";

// Drives the pending-tasks count badge on the "My Tasks" nav item
// (ClassyLayoutComponent). A single shared source so every subscriber sees
// the same count without each issuing its own request.
@Injectable({ providedIn: "root" })
export class TaskBadgeService {
  private _pendingCount = new BehaviorSubject<number>(0);
  readonly pendingCount$ = this._pendingCount.asObservable();

  constructor(private _apiService: ApiService) {}

  refresh(): void {
    this._apiService.get(API_ROUTE.MY_TASK.getStatus).subscribe({
      next: (res: any) => {
        const data = res?.data || res || {};
        this._pendingCount.next(data.pending ?? 0);
      },
      error: () => {
        // Keep the last known count on failure rather than flashing to 0.
      },
    });
  }
}
